<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
              <div class="alert" :class="'alert-' + flashType">
                {{ flashMessage }}
              </div>
            </div>
          </div>
          <div id="details" class="row">
            <div class="col-sm-12 text-right">
              <button class="btn btn-danger mr-5" type="button" @click="deleteRegionModal">
                Delete G.A
              </button>
            </div>
            <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.name)">
                    <label>Geographical Area Name</label>
                    <input type="text" minlength="3" name="name" class="form-control" required v-model.lazy="region.name"
                      placeholder="G.A Name" />
                    <field-messages name="name" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">G.A name is a required field</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.status)">
                    <label>Status</label>
                    <select v-model="region.status" name="status" class="form-control">
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                    <field-messages name="status" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">Status is a required field</div>
                      <div slot="pattern">Status is invalid</div>
                    </field-messages>
                  </validate>

                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.regionManager)">
                    <label>HCV Operation Manager</label>
                    <select required v-model="region.regionManager" name="regionManager" class="form-control">
                      <option disabled>Select G.A Head</option>
                      <option v-for="(item, index) in managers" :key="index" :value="item.key">
                        {{ item.value }}
                      </option>
                    </select>
                    <field-messages name="regionManager" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">
                        HCV Operation Manager is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <label for="journeyManager" class="control-label">
                    Journey Manager
                  </label>
                  <!-- <div class="col-sm-5"> -->
                  <vue-select label="journeyManager" @input="flagButtonCheck" multiple :options="this.journey_managers"
                    :searchable="true" language="en-US" v-model="region.journeyManager">
                  </vue-select>
                  <div v-if="!flagButton" style="color: red;" class="error-message">
                    Please select at least one Journey Manager.
                  </div>
                  <!-- </div> -->
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <label for="jmaUser" class="control-label">
                    JMA Users
                  </label>
                  <!-- <div class="col-sm-5"> -->
                  <vue-select label="jmaUser" multiple @input="flagButtonCheck1" :options="this.jma_users"
                    :searchable="true" language="en-US" v-model="region.jmaUser">
                  </vue-select>
                  <div v-if="!flagButton1" style="color: red;" class="error-message">
                    Please select at least one JMA User.
                  </div>
                  <!-- </div> -->
                </div>
                <div class="col-sm-6">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.regionCode)">
                    <label>Region Code</label>
                    <input type="text" name="regionCode" class="form-control" required v-model.lazy="region.regionCode"
                      placeholder="Region Code" pattern="[A-Z]{2}">
                    <field-messages name="regionCode" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">Region Code is a required field</div>
                      <div slot="pattern">Region Code is invalid</div>
                      <div slot="minlength">Minimum length of Region Code is 3 character</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
            </vue-form>
            <div class="col-sm-12 text-right">
              <router-link :to="{ name: 'Region' }">
                <button class="mr-5 btn btn-default" type="button">
                  Cancel
                </button>
              </router-link>
              <button class="mr-2 btn gradientbt" type="submit" @click="updateRegion"
                :disabled="!(formstate.$dirty && formstate.$valid && flagButton && flagButton1)">
                Update G.A
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formService, eventBus, regionService } from '../../../services';
import { EVENTS } from '../../../config';
import swal from 'sweetalert2';

export default {
  name: 'RegionDetail',
  data() {
    return {
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: EVENTS,
      formstate: {},
      region: {},
      journey_managers: '',
      journey: [],
      jmauser: [],
      managers: '',
      jma_users: '',
      flagButton: false,
      flagButton1: false
    };
  },
  mounted: function () {
    this.getManager();
  },
  methods: {
    fieldClassName: formService.fieldClassName,


    flagButtonCheck() {
      if (this.region.journeyManager.length > 0) {
        this.flagButton = true;
        this.formstate.status.$dirty = true;
      } else {
        this.flagButton = false
      }
    },
    flagButtonCheck1() {
      if (this.region.jmaUser.length > 0) {
        this.flagButton1 = true;
        this.formstate.status.$dirty = true;
      } else {
        this.flagButton1 = false
      }

    },

    getRegion() {
      return this.$regionDataRepository
        .find(this.$route.params._id)
        .then(response => {
          this.region = response.data;
          console.log('aaaaaaaaaaaaaaaaaaaaaaa', this.region)
          if (this.region.journeyManager.length > 0) {
            this.flagButton = true;
          }
          if (this.region.jmaUser && this.region.jmaUser.length > 0) {
            this.flagButton1 = true;
          }
          this.getJourneyManager();
          this.getJmaUsers();
        })
        .catch(error => {
          this.$snotify.error('Region detail failed', 'Error!');
        });
    },
    updateRegion() {
      this.loading = true;
      this.region.journeyManager = this.region.journeyManager.map(item => {
        return item.value;
      });
      this.region.jmaUser = this.region.jmaUser.map(item => {
        return item.value;
      });
      return regionService
        .updateRegion(this.region)
        .then(response => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success('Region updated!', 'Success!');
          this.$router.push('/ga');
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Region update failed!Try Again', 'Error!');
          if (error.data.message.includes('must be one of')) {
            this.flash = true;
            this.flashType = 'error';
            this.flashMessage = 'New region update is failed.Please try again!';
          }
        });
    },
    deleteRegionModal() {
      swal({
        title: 'Are you sure?',
        text: 'This will permanently delete this Geographic Area!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(result => {
        if (result.value) {
          this.deleteRegion();
        }
      });
    },
    deleteRegion() {
      this.loading = true;
      return this.$regionDataRepository
        .deleteOne(this.region._id)
        .then(response => {
          this.loading = false;
          return swal(
            'Deleted!',
            'Geographical Area has been deleted.',
            'success',
          );
        })
        .then(response => {
          this.loading = false;
          this.$router.push('/ga');
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Delete region failed', 'Error!');
        });
    },
    fieldClassName: function (field) {
      if (!field) {
        return '';
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return 'has-success';
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'has-danger';
      }
    },
    getManager() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.roleRank = 2;
      let managerlist = [];
      this.$userRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            managerlist = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.firstName + ' ' + item.lastName,
              };
            });
          }
          this.managers = managerlist;
        })
        .catch(error => {
          this.loading = false;
          console.error('Manager.requestFunction-error:', error);
          this.$snotify.error('Get manager list failed', 'Error!');
        });
    },

    getJourneyManager() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.roleRank = 3;
      let journeyManagerlist = [];
      this.$userRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            journeyManagerlist = res.data.docs;
          }
          this.journey_managers = journeyManagerlist.map(item => {
            return {
              value: item._id,
              journeyManager: `${item.firstName} ${item.lastName}`,
            };
          });

          journeyManagerlist.map(item => {
            if (this.region.journeyManager.includes(item._id)) {
              this.journey.push({
                value: item._id,
                journeyManager: `${item.firstName} ${item.lastName}`,
              });
            }
          });
          
          this.region.journeyManager = this.journey;
          console.log(
            'this.region.journeyManager',
            this.region.journeyManager,
            this.journey,
          );
        })
        .catch(error => {
          this.loading = false;
          console.error('Manager.requestFunction-error:', error);
          this.$snotify.error('Get Journey Manager list failed', 'Error!');
        });
    },

    /*get JMA Users*/
    getJmaUsers() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.roleRank = 10;
      params.isDeleted = false;
      params.isActive = true;
      let jmaUsersList = [];
      this.$userRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            jmaUsersList = res.data.docs;
            this.jma_users = jmaUsersList.map(item => {
              return {
                value: item._id,
                jmaUser: `${item.firstName} ${item.lastName}`,
              };
            });

            jmaUsersList.map(item => {
              if (this.region.jmaUser && this.region.jmaUser.includes(item._id)) {
                this.jmauser.push({
                  value: item._id,
                  jmaUser: `${item.firstName} ${item.lastName}`,
                });
              }
            });
            this.region.jmaUser = this.jmauser;
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('Manager.requestFunction-error:', error);
          this.$snotify.error('Get Journey Manager list failed', 'Error!');
        });
    },
  },

  created() {
    const promises = [];
    this.loading = true;
    promises.push(this.getRegion());
    Promise.all(promises)
      .then(() => {
        this.loading = false;
        this.ready = true;
      })
      .catch(() => {
        this.loading = false;
      });
  },
};
</script>
<style scoped>
.required-field>label::after,
label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}

.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}

.has-danger {
  color: red;
}

.gradientbt {
  background-image: linear-gradient(to right,
      rgba(38, 153, 251),
      rgba(146, 205, 255));
  color: white;
}
</style>



// WEBPACK FOOTER //
// RegionDetail.vue?59251988